/* eslint-disable react/no-multi-comp */
import React from 'react';
import { useTranslation } from 'react-i18next';

import connect from '@app/utils/connect';

import getCollections from '@app/actions/collections/getCollections';
import getPosts from '@app/actions/media/getPosts';
import sendNotification from '@app/actions/notifications/send';
import removeCollectionFromPost from '@app/actions/media/removeCollectionFromPost';
import addCollectionsToPosts from '@app/actions/media/addCollectionToPosts';
import clearOverrideFilters from '@app/actions/media/clearOverrideFilters';
import setIsReturningFromOverride from '@app/actions/media/setIsReturningFromOverride';
import combineActions from '@app/utils/combineActions';

import { FILTER_ORIGIN } from '@app/constants/filters';

import ErrorBoundary from '@app/ErrorBoundary';
import CrashedComponent from '@app/components/errors/CrashedComponent';

import ReFilters from '@app/components/filters';
import SmpProvider, { useSmpContext } from './SmpContext';

import FiltersOverrideRow from './FiltersOverrideRow';
import ActionButtonsV2 from './ActionButtons';
import SocialMediaViews from './SocialMediaViews';
import SocialMediaPostModals from './SocialMediaPostModals';

import { Typography, Flex } from '@app/ui';

const ReFiltersWithContext = () => {
    const { filtersOverride } = useSmpContext();
    return (
        <ReFilters
            origin={FILTER_ORIGIN.SMP}
            isOverridingFilters={!!filtersOverride}
        />
    );
};

const SocialMediaPosts = () => {
    const { t } = useTranslation('measurement');

    return (
        <SmpProvider>
            <Flex
                vertical
                style={{
                    padding: 24,
                }}
            >
                <div id="top" />
                <Flex>
                    <Typography.Title
                        level={4}
                        style={{
                            margin: 0,
                            color: '#1f1f1f',
                            fontWeight: 400,
                            marginBottom: 24,
                            paddingLeft: 12,
                            fontSize: 32,
                        }}
                    >
                        {t('socialMediaExposure.title')}
                    </Typography.Title>
                </Flex>

                <FiltersOverrideRow />

                <div>
                    <ErrorBoundary FallbackComponent={CrashedComponent}>
                        <ReFiltersWithContext />
                    </ErrorBoundary>

                    <ActionButtonsV2 />

                    <SocialMediaViews />

                    <SocialMediaPostModals />
                </div>
            </Flex>
        </SmpProvider>
    );
};

export default connect(
    ['media', 'filters', 'collections', 'client', 'user'],
    combineActions({
        getCollections,
        getPosts,
        sendNotification,
        removeCollectionFromPost,
        addCollectionsToPosts,
        clearOverrideFilters,
        setIsReturningFromOverride,
    }),
)(SocialMediaPosts);
